<template>
    <div>
        <div>
            <el-form :model="form"  :inline="true"  style="text-align:left;">
                <el-form-item label="综合查询:">
                    <el-input v-model="form.name"   placeholder="请输入承销商/机构名称" :clearable="true" class="query-input"></el-input>
                </el-form-item> 
                <el-form-item label="状态:">
                    <My-Select v-model="form.state" :objSelect="form.state" :options="options" @changeSelct="changeSelct"></My-Select>                 
                </el-form-item> 
                <el-form-item >
                    <el-button type="primary" plain @click="query()">查询</el-button>  
                    <el-button type="primary" plain @click="underwriterEditor('add')">新建</el-button>                         
                </el-form-item>           
            </el-form>
        </div>
        <div>
            <My-table :configurationData="configurationData" :operation="operation" :getTableParam="getTableParam" ref="myTable">           
                <template #operation="scope">        
                    <el-button size="mini" type="primary" @click="underwriterEditor('update',scope.row)">修改</el-button>
                </template>
            </My-table> 
        </div>

        <el-dialog :title="title"  :visible.sync="underwriterEditorDialog" :close-on-click-modal=false width="1200px">
            <el-form :model="underwriterForm"  :inline="true"  :rules="rules" ref="underwriterForm" label-width="100px" style="text-align:left">
                <el-row>
                    <el-col :span="11">
                        <el-form-item label="承销商名称:" prop="agentName" class="underwriter-input">
                            <el-input v-model="underwriterForm.agentName" placeholder="请输入承销商名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="13">
                        <el-form-item label="地址:" prop="area" class="address-select">
                            <el-cascader
                                    v-model="underwriterForm.area"
                                    :props="props"
                                    :options="options_cascader"
                                    :key="isResouceShow"
                                    placeholder="请选择省市区" 
                                    ></el-cascader>
                        </el-form-item>
                        <el-form-item label="" prop="address" class="address-input">
                            <el-input v-model="underwriterForm.address" placeholder="请输入详细地址"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="11">
                        <el-form-item label="客服电话" prop="phone" class="underwriter-input">
                            <el-input v-model="underwriterForm.phone" placeholder="请输入客服电话"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="13">
                        <el-form-item label="状态:" prop="state" >
                            <el-switch v-model="underwriterForm.state"></el-switch>
                        </el-form-item>   
                    </el-col>
                </el-row>
            </el-form>
            <el-row style="text-align:right;">
                <el-col >
                    <el-button type="success" plain size="mini" @click="addRow(underwriterForm.agentBranchModifyDtoList)">新增</el-button>
                </el-col>               
            </el-row>
            <el-table :data="underwriterForm.agentBranchModifyDtoList" border style="width: 100%;margin-top:5px;">
                <el-table-column label="*机构名称">
                    <template slot-scope="scope">
                        <p v-show=!scope.row.isShow> {{ scope.row.agentBranName }}</p>
                        <el-input placeholder="please input" v-model="scope.row.agentBranName" v-show="scope.row.isShow" size="medium"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="省市区" >
                    <template slot-scope="scope">
                        <p v-show=!scope.row.isShow> {{ formatAreaItem(scope.row.area) }}</p>
                        <el-cascader
                                v-model="scope.row.area"
                                :props="props"
                                :options="options_cascader"
                                :key="isResouceShow"
                                v-show="scope.row.isShow" 
                                ></el-cascader>         
                    </template>
                </el-table-column>
                <el-table-column label="详细地址" >
                    <template slot-scope="scope">
                        <p v-show=!scope.row.isShow> {{ scope.row.address }}</p>
                        <el-input placeholder="please input" v-model="scope.row.address" v-show="scope.row.isShow" size="medium"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="tableEdit(scope.$index, scope.row)"  v-show=!scope.row.isShow>编辑</el-button>
                        <el-button size="mini" @click="tableEnter(scope.$index, scope.row)"  v-show=scope.row.isShow>确定</el-button>
                        <el-button size="mini" type="danger" @click="deleteRow(scope.$index,scope.row)">删除</el-button>
                        <el-button size="mini" v-show="scope.row.state=='Y'" type="danger" @click="stateUpdate(scope.$index,scope.row,'N')">停用</el-button>
                        <el-button size="mini" v-show="scope.row.state=='N'" type="danger" @click="stateUpdate(scope.$index,scope.row,'Y')">启用</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[5, 10, 20, 30, 40]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next,jumper"
                :total="totalNum">
            </el-pagination>
            <div slot="footer" style="text-align:center">
                <el-button type="primary" @click="submitForm('underwriterForm')">确定</el-button>
                <el-button @click="resetForm('underwriterForm')">取消</el-button>
            </div>
        </el-dialog>
          
    </div>
</template>

<script>
import common from "../../../public/static/common.js";
import  asyncApi   from '../../api/asyncApi';
export default { 
    name: 'underwriterManagement',
    data(){
        let recme = this;
        return{       
            title:'',    
            pageNum: 1, // 当前页，默认1
            pageSize: 10, // 每页行数，默认10         
            totalNum: 0, // 总数
            isShow:false,
            operationType:'',
            placeholder:'请选择查询状态',
            form:{
                name:'',
                state:''
            },
            underwriterForm:{
                id:'',
                agentName:'',
                areaProvince:'',
                areaCity:'',
                areaCounty:'',
                address:'',
                phone:'',
                state:true,
                createUser:'',
                modifyUser:'',
                area:[],
                agentBranchModifyDtoList:[{
                    id:'',
                    agentCode:'',
                    agentBranName:'',
                    areaProvince:'',
                    areaCity:'',
                    areaCounty:'',
                    address:'',
                    area:[],
                    state:'Y',
                    isShow:true,
                    areaDisplay:""
                }]
            },            
            orgTableList:[],
             // 列表配置
            configurationData:[
                {
                    title: '承销商名称',
                    propertys: 'agentName',
                    width: ''
                },
                {
                    title: '机构名称',
                    propertys: 'agentBranName',
                    width: ''
                },{
                    title: '省市区',
                    propertys: 'addressLink',
                    width: ''
                },
                {
                    title: '详细地址',
                    propertys: 'address',
                    width: ''
                },
                {
                    title: '状态',
                    propertys: 'state',
                    width: '',
                    format:common.formatState
                }
            ],
             // 是否有操作按钮 宽度
            operation: {
                show: true,
                width: ''
            },
            getTableParam:{
                url:'/extwarapi/api/agent/page',
                param:''
            },
            underwriterEditorDialog:false,
            options:[
                {"key":'',"value":'全部'},
                {"key":'N',"value":'停用中'},
                {"key":'Y',"value":'使用中'}
            ],
            options_cascader:[],
            isResouceShow: "0",
            props:{
                value: 'name',
                label: 'name',
                children: 'cities' ,
                lazy: true,
                async lazyLoad (node, resolve) {                  
                    const { level } = node;
                    let nodes = [];
      
                    if(level ==0){
                        await recme.getProvince();
                        nodes = recme.provinceList;
                    }
                    if(level ==1){
                        await recme.getCity(node.data.code);                       
                        nodes = recme.cityList;
                    }
                    if(level ==2){
                        await recme.getDistricts(node.data.code);                       
                        nodes = recme.districtList;
                        nodes.forEach(element => {
                            element.leaf = true;
                        });
                    }
                    setTimeout(() => {                       
                        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                        resolve(nodes);
                    }, 200);
                }               
            },
            rules: {
                agentName: [
                    { required: true, message: '请输入承销商名称', trigger: 'blur' }
                ],
                area: [
                    { required: true, message: '请选择省市区', trigger: 'blur' }
                ],
                address: [
                    { required: true, message: '请输入详细地址', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入客服电话', trigger: 'blur' }
                ]
            }
        }
    },
    methods:{
        underwriterEditor(operationType,row){
            this.operationType=operationType;
            if(operationType=='update'){
                this.pageNum=1;
                this.title='承销商及机构修改';
                this.options_cascader=[];
                ++this.isResouceShow;  
                this.getDetail(row.agentId);                
            }else{
                //添加
                this.title='承销商及机构新增';
                this.underwriterForm=common.emptyModel(this.underwriterForm,["state"]);
                this.underwriterForm.agentBranchModifyDtoList=[];
                this.orgTableList=[];
                this.totalNum=0;
            }
            this.$nextTick(() => {                
                this.underwriterEditorDialog=true;
            });            
        },
        query(){
            this.getTableParam.param=this.form;
            this.$refs.myTable.query(1);
        },
        formatAreaItem(value) {
           if(value){
                let areaItem='';
                for(let i = 0; i < value.length; i++){
                    if(value[i]!=null){
                        areaItem += value[i]+"/";
                    }
                }
                return areaItem.substr(0,areaItem.length-1);
           }           
        },
        addRow(){
            var row={
                agentBranName:'',
                areaProvince:'',
                areaCity:'',
                areaCounty:'',
                address:'',
                area:'',
                state:'Y',
                isShow:true
            }
            this.orgTableList.push(row);
            this.totalNum++;
            this.pageNum=this.totalNum%this.pageSize==0?(this.totalNum/this.pageSize):(Math.floor(this.totalNum/this.pageSize)+1)
            this.getPageList();           
        },
        tableEdit(index,row){   
          row.isShow = true;
          this.$set(this.underwriterForm.agentBranchModifyDtoList,index, row);
        },
        tableEnter(index,row){
            if(row.agentBranName===''){
                this.$alert('机构名称为必填项', '提示信息', {
                    confirmButtonText: '确定',
                    callback: action => {
                        row.isShow = true;
                    }
                });
            }else{
                row.isShow = false;
                if(this.operationType=='add'){
                    this.$set(this.underwriterForm.agentBranchModifyDtoList,index, row);
                }
                //修改的时候编辑表格调用接口
                if(this.operationType=='update'){
                    this.updateOrganization(index,row);
                }                
            }     
        },
        deleteRow(index, row) {
            if(this.operationType=='add'){
                this.orgTableList.splice(index, 1);
                this.underwriterForm.agentBranchModifyDtoList.splice(index, 1);
                this.totalNum--;
            }else{                
                //修改的时候删除表格数据调用接口
                if(row.id){
                    row.state='D';
                    this.updateOrganization(index, row);
                }else{
                    this.orgTableList.splice(index, 1);
                    this.underwriterForm.agentBranchModifyDtoList.splice(index, 1);
                    this.totalNum--;
                }
            }
        } ,
        handleSizeChange(val) {  
            this.pageSize = val;        
        },
        handleCurrentChange(val) {  
            this.pageNum = val;
        },
        getPageList(){            
            let startRow = (this.pageNum - 1) * this.pageSize+1-1;//开始显示的行  
            let endRow = this.pageNum * this.pageSize;//结束显示的行
            endRow = (endRow > this.totalNum)? this.totalNum : endRow;
            this.underwriterForm.agentBranchModifyDtoList=this.orgTableList.slice(startRow,endRow);  
        },
        changeSelct(value){
            this.form.state=value;
        },
        //表格启用/关闭
        stateUpdate(index,row,stateType){
            row.state=stateType;
            this.updateOrganization(index,row);
        },
        submitForm(formName) {
            let usercode=common.getCurrUser().userCode;
            let url="";
            let param=Object.assign({},this.underwriterForm);
            param.createUser=usercode;
            param.modifyUser=usercode;
            //表单地址
            param.areaProvince=param.area[0];
            param.areaCity=param.area[1];
            param.areaCounty=param.area[2];            
            //表单状态
            if(param.state){
                param.state='Y'
            }else{
                param.state='N'
            }
            if(this.operationType=='add'){
                url="/extwarapi/api/agent/add";
                //表格地址         
                if(param.agentBranchModifyDtoList.length>0){
                    for(let i=0;i<param.agentBranchModifyDtoList.length;i++){
                        let agentBranchArea= param.agentBranchModifyDtoList[i].area;
                        param.agentBranchModifyDtoList[i].areaProvince= agentBranchArea[0];
                        param.agentBranchModifyDtoList[i].areaCity= agentBranchArea[1];
                        param.agentBranchModifyDtoList[i].areaCounty= agentBranchArea[2];                
                    }                
                }
            }else{
                url="/extwarapi/api/agent/update";
                param.agentBranchModifyDtoList=[];
            }
                    
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.axios.post(url, param).then((resp) => {  
                        if(resp.data.code=='0000'){
                            this.$alert("操作成功!", '提示信息', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    this.underwriterEditorDialog=false;
                                    this.$refs["myTable"].query(1);  
                                }
                            });
                        }else{
                            this.$alert(resp.data.msg, '提示信息', {
                                confirmButtonText: '确定',
                                callback: action => {
                                
                                }
                             });
                            return;
                        }              
                    }).catch((resp) => {
                        //console.log('error', resp); 
                    })
                } else {
                    //console.log('error submit!!');
                    return false;
                }
            });
        },
        updateOrganization(index,row){
            let usercode=common.getCurrUser().userCode;
            let url="";
            if(row.id){
                url="/extwarapi/api/agent/updateOrganization";
            }else{
                row.agentCode=this.underwriterForm.agentCode;
                url="/extwarapi/api/agent/addOrganization";
            }            
            let param={
                agentCode:row.agentCode,
                id:row.id,
                agentBranName:row.agentBranName,
                areaProvince:row.area[0],
                areaCity:row.area[1],
                areaCounty:row.area[2],
                address:row.address,
                createUser:usercode,
                modifyUser:usercode,
                state:row.state
            }
            //console.log(param);
            this.axios.post(url, param).then((resp) => { 
                    if(resp.data.code=='0000'){
                        if(row.state=='D'){
                            this.orgTableList.splice(index, 1);
                            this.underwriterForm.agentBranchModifyDtoList.splice(index, 1);
                            this.totalNum--;
                        }else{
                            this.$set(this.underwriterForm.agentBranchModifyDtoList,index, row);
                        }                        
                    }else{
                        this.$alert(resp.data.msg, '提示信息', {
                            confirmButtonText: '确定',
                            callback: action => {
                            
                            }
                            });
                    }                
                }).catch((resp) => {
                        //console.log('error', resp); 
                });
        },
        resetForm(formName) {
            this.underwriterEditorDialog=false;
            this.$refs[formName].resetFields(); 
        },
        getDetail(agentId){
            let url='/extwarapi/api/agent/getDetailById';
            this.axios.post(url, {id:agentId}).then((resp) => {
                    if(resp.data.code=='0000'){
                        let data=resp.data.result;                    
                        this.underwriterForm.area=[];
                        this.underwriterForm.id=data.id;

                        this.underwriterForm.agentName=data.agentName;
                        this.underwriterForm.agentCode=data.agentCode;
                        this.underwriterForm.area=[data.areaProvince,data.areaCity,data.areaCounty];
                        this.underwriterForm.address=data.address;
                        this.underwriterForm.phone=data.phone;
                        this.underwriterForm.agentBranchModifyDtoList=data.agentBranchDtoList;    
                        for(let i=0;i<this.underwriterForm.agentBranchModifyDtoList.length;i++){
                            let itemArea = [];
                            itemArea.push(data.agentBranchDtoList[i].areaProvince);
                            itemArea.push(data.agentBranchDtoList[i].areaCity);
                            itemArea.push(data.agentBranchDtoList[i].areaCounty);
                            this.underwriterForm.agentBranchModifyDtoList[i].area = itemArea;
                            this.underwriterForm.agentBranchModifyDtoList[i].address=data.agentBranchDtoList[i].address;
                            this.underwriterForm.agentBranchModifyDtoList[i].agentCode=data.agentBranchDtoList[i].agentCode;
                            this.underwriterForm.agentBranchModifyDtoList[i].id=data.agentBranchDtoList[i].id;
                        }
                        this.orgTableList=this.underwriterForm.agentBranchModifyDtoList;                    
                        this.totalNum=this.underwriterForm.agentBranchModifyDtoList.length;
                        //this.pageNum=this.totalNum%this.pageSize==0?(this.totalNum/this.pageSize):(Math.floor(this.totalNum/this.pageSize)+1)
                        this.getPageList();
                    }
            }).catch((resp) => {
                        //console.log('error', resp); 
            });
        },
        async  getProvince () { 
            let url ="/extwarapi/api/tools/getProvince";
            let data = await asyncApi.post(url,{});  
            if(data.code=='0000'){
                this.provinceList= common.conversionList(data.result,'provinceCode','code','provinceName','name');
            }
        },
        async  getCity (code) {
            let url ="/extwarapi/api/tools/getCity";
            let data = await asyncApi.post(url,{code:code});  
            if(data.code=='0000'){
                this.cityList= common.conversionList(data.result,'cityCode','code','cityName','name');
            }
        },
        async  getDistricts (code) {
            let url ="/extwarapi/api/tools/getDistricts";
            let data = await asyncApi.post(url,{code:code});  
            if(data.code=='0000'){
                this.districtList= common.conversionList(data.result,'districtCode','code','districtName','name');
            }
        }, 
    },
    mounted(){
        this.getProvince();
    },
    watch:{
        pageNum(newVal, oldVal){
            if(newVal!==oldVal){                
                this.getPageList();
            }
        },
        pageSize(newVal, oldVal){
            if(newVal!==oldVal){
                this.getPageList();
            }
        }
    }
 
}
</script>
<style lang="scss" >
.address-select .el-input--suffix{
    width: 240px;
}
.address-input .el-input{
    width: 268px;
}
.underwriter-input .el-input{
    width: 300px;
}
</style>